import { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { IDialectResponse } from '../app/core/interfaces/dialect-response.interface';
import { CreateQueryRequestDto } from '../dtos/requests/CreateQueryRequestDto';
import { SortablePageRequestDto } from '../dtos/requests/SortablePageRequestDto';
import { PageDto } from '../dtos/responses/PageDto';
import { QueryResponseDto } from '../dtos/responses/QueryResponseDto';
import { environment as env, environment } from '../environments/environment';

interface Pageable {
  page?: number;
  size?: number;
  search?: string;
}

function toPageable(sortablePageRequestDto: SortablePageRequestDto): Pageable {
  return {
    page: sortablePageRequestDto.page,
    size: sortablePageRequestDto.size,
    search: sortablePageRequestDto.search || '',
  };
}

@Injectable({ providedIn: 'root' })
export class DialectService {
  private readonly api = environment.gateway.url;

  constructor(private httpClient: HttpClient) {}

  private toQueryParams(object: object): string {
    const params = Object.keys(object)
      .map((key) => `${key}=${object[key as keyof object]}`)
      .join('&');
    return params.replace(/[^=&]+=&/g, '').replace(/&*[^=&]+=$/, '');
  }

  dialectDetails(query: string) {
    return this.httpClient.get<IDialectResponse>(`${this.api}/catalog-dialect/v1/queries/${query}`);
  }

  getQuery(id: string): Observable<QueryResponseDto> {
    return this.httpClient.get<QueryResponseDto>(
      env.local ? `http://localhost:8080/api/v1/queries/${id}` : `${env.gateway.url}/catalog-dialect/v1/queries/${id}`
    );
  }

  getQueries(sortablePageRequestDto: SortablePageRequestDto): Observable<PageDto<QueryResponseDto>> {
    const params = this.toQueryParams(toPageable(sortablePageRequestDto));
    return this.httpClient.get<PageDto<QueryResponseDto>>(
      env.local ? `http://localhost:8080/api/v1/queries?${params}` : `${env.gateway.url}/catalog-dialect/v1/queries?${params}`
    );
  }

  deleteQuery(id: string): Observable<void> {
    return this.httpClient.delete<void>(env.local ? `http://localhost:8080/api/v1/queries/${id}` : `${env.gateway.url}/catalog-dialect/v1/queries/${id}`);
  }

  saveQuery(queryRequest: CreateQueryRequestDto): Observable<void> {
    return this.httpClient.post<void>(env.local ? `http://localhost:8080/api/v1/queries` : `${env.gateway.url}/catalog-dialect/v1/queries`, queryRequest);
  }

  updateQuery(queryId: string, queryRequest: CreateQueryRequestDto): Observable<void> {
    return this.httpClient.put<void>(
      env.local ? `http://localhost:8080/api/v1/queries` : `${env.gateway.url}/catalog-dialect/v1/queries/${queryId}`,
      queryRequest
    );
  }

  path(queryId: string, active: boolean) {
    return this.httpClient.patch<void>(env.local ? `http://localhost:8080/api/v1/queries` : `${env.gateway.url}/catalog-dialect/v1/queries/${queryId}`, {
      active,
    });
  }
}
